import { NotebookModule } from '@/store/modules/notebook';
import { UserModule } from '@/store/modules/user';

export interface NotepadJob {
  id: number
  title: string
  firmName: string
  location: string
  date: string
  shortview?: string
}

export const isJobInNotepad = (id: number): boolean => NotebookModule.notebookJobs.some((x: { id: number }) => x.id === id);

// Logged in: the notebook on the server; otherwise kept in the browser (localStorage)
export const toggleJobNotepad = async(job: NotepadJob): Promise<void> => {
  const isMarked = isJobInNotepad(job.id);
  if (UserModule.isUserAuth) {
    await NotebookModule.toogleNotepadItem({ type: 'job', item_id: job.id, isMarked });
    return;
  }
  NotebookModule.setJobNotepadItemLocal({
    isMarked,
    id: job.id,
    position: job.title,
    location: job.location,
    lastdate: job.date,
    company_name: job.firmName,
    shortview: job.shortview || '',
  });
};
